module.exports = __webpack_public_path__ + "static/img/user.d2c2b2d0.png";